import { STATUS_MONITOR_PROFILING_TAGS } from 'helpers/sf_constants';
import {
  GET_CUSTOMER_INCIDENTS,
  GET_CUSTOMER_INCIDENTS_SUCCESS,
  GET_CUSTOMER_INCIDENTS_ERROR,
  GET_TIMEFRAME_REPORTING_DATA,
  GET_TIMEFRAME_REPORTING_DATA_SUCCESS,
  GET_TIMEFRAME_REPORTING_DATA_ERROR,
  CREATE_CUSTOMER_INCIDENTS,
  CREATE_CUSTOMER_INCIDENTS_SUCCESS,
  CREATE_CUSTOMER_INCIDENTS_ERROR
} from './actionTypes';

const INIT_STATE = {
  dashboardData: null,
  reportingData: null,
  billingData: null,
  integrationData: null,
  analyticsData: null,
  campaignsData: null,
  adsData: null,
  customer_incidents: null,
  isLoading: false,
  error: null
}


const StatusMonitor = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_CUSTOMER_INCIDENTS:
      return {
        ...state,
        isLoading: true
      };
    case GET_CUSTOMER_INCIDENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        customer_incidents: action.payload
      };
    case GET_CUSTOMER_INCIDENTS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    
    case CREATE_CUSTOMER_INCIDENTS:
      return {
        ...state,
        isLoading: true
      };
    case CREATE_CUSTOMER_INCIDENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        customer_incidents: [...state.customer_incidents, action.payload],
      };
    case CREATE_CUSTOMER_INCIDENTS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    
    case GET_TIMEFRAME_REPORTING_DATA:
      return {
        ...state,
        isLoading: true
      };
    case GET_TIMEFRAME_REPORTING_DATA_SUCCESS:
      if (action.profilingTagId === STATUS_MONITOR_PROFILING_TAGS.DASHBOARD) {
        return {
          ...state,
          isLoading: false,
          dashboardData: action.payload
        };
      } else if (action.profilingTagId === STATUS_MONITOR_PROFILING_TAGS.REPORTING) {
        return {
          ...state,
          isLoading: false,
          reportingData: action.payload
        };
      } else if (action.profilingTagId === STATUS_MONITOR_PROFILING_TAGS.BILLING) {
        return {
          ...state,
          isLoading: false,
          billingData: action.payload
        };
      } else if (action.profilingTagId === STATUS_MONITOR_PROFILING_TAGS.INTEGRATION) {
        return {
          ...state,
          isLoading: false,
          integrationData: action.payload
        };
      } else if (action.profilingTagId === STATUS_MONITOR_PROFILING_TAGS.ANALYTICS) {
        return {
          ...state,
          isLoading: false,
          analyticsData: action.payload
        };
      } else if (action.profilingTagId === STATUS_MONITOR_PROFILING_TAGS.CAMPAIGN_STATS) {
        return {
          ...state,
          isLoading: false,
          campaignsData: action.payload
        };
      } else if (action.profilingTagId === STATUS_MONITOR_PROFILING_TAGS.AD_STATS) {
        return {
          ...state,
          isLoading: false,
          adsData: action.payload
        };
      };
    case GET_TIMEFRAME_REPORTING_DATA_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
  
    default:
      return state;
  }
};

export default StatusMonitor;